"use client";

import * as React from "react";
import Link from "next/link";
import { ChartCard, PreviewLineChart } from "@/components";
import { ChartLineIcon } from "@/icons";
import { useRoiFromLaunch } from "@/hooks/use-roi";
import { buildRoiLines } from "@/utils";

export function Roi() {
  const { data, isLoading } = useRoiFromLaunch();
  const fields = React.useMemo(() => data?.chart?.fields, [data]);
  const { lines } = React.useMemo(() => buildRoiLines(fields), [fields]);

  return (
    <Link href="/explore/roi" className="block h-full cursor-pointer">
      <ChartCard
        title="ROI"
        icon={<ChartLineIcon size={20} color="#FF0F6F" />}
        isLoading={isLoading}
        accent="Cross-asset"
        description="HEX vs BTC, ETH, and other assets since launch"
      >
        <PreviewLineChart data={data?.data ?? []} lines={lines} />
      </ChartCard>
    </Link>
  );
}
